<template>
	<div class="container">
		<el-form
			ref="filtrateForm"
			size="mini"
			:inline="true"
			:model="form"
			class="form"
		>
			<el-form-item style="display:block">
				<el-button type="primary" @click="onCreateClick"
					>添加自营商品</el-button
				>
				<el-button @click="onSupplySettingClick">默认供货价加润</el-button>
				<el-button @click="onSaleSettingClick">默认在售价加润</el-button>
			</el-form-item>
			<el-form-item label="商品分类：">
				<el-select
					style="width:130px;"
					v-model="form.parent_id"
					@change="classifyChange"
				>
					<el-option label="全部" value></el-option>
					<el-option
						v-for="(item, index) in classifyList"
						:key="index"
						:label="item.name"
						:value="item.id"
					>
					</el-option>
				</el-select>
				<el-select style="width:130px;margin-left:8px;" v-model="form.cate_id">
					<el-option
						v-for="(item, index) in sonClassifyList"
						:key="index"
						:label="item.name"
						:value="item.id"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="来源：">
				<!-- <el-select style="width:130px;" v-model="form.supply_id">
					<el-option label="全部" value></el-option>
					<el-option
						v-for="(item, index) in sourceList"
						:key="index"
						:label="item.name"
						:value="item.id"
					></el-option>
				</el-select> -->
				<el-autocomplete
					popper-class="my-autocomplete"
					v-model="AutoVal"
					:fetch-suggestions="querySearch"
					placeholder="请输入内容"
					@select="handleSelect"
				>
					<template slot-scope="{ item }">
						<div class="name">{{ item.name }}</div>
					</template>
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="供应商：">
				<el-autocomplete
					popper-class="my-autocomplete"
					v-model="supplierName"
					:fetch-suggestions="querySearch1"
					placeholder="请输入内容"
					@select="handleSelect1"
				>
					<template slot-scope="{ item }">
						<div class="name">{{ item.supplier_name }}</div>
					</template>
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="对接方式：">
				<el-select style="width:130px;" v-model="form.docking_type">
					<el-option label="全部" value></el-option>
					<el-option label="1688接入" value="1"></el-option>
					<el-option label="供应商接入" value="2"></el-option>
					<el-option label="自营创建" value="0"></el-option>
					<el-option label="盈锐接入" value="5"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="同步条件：">
				<el-select style="width:130px;" v-model="form.auto_sync">
					<el-option label="全部" value="0"></el-option>
					<el-option label="自动同步" value="1"></el-option>
					<el-option label="手动同步" value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="价格区间：">
				<el-col :span="12">
					<el-input v-model="form.min_sale_price" placeholder="输入最低价格">
						<el-select
							style="width:100px;"
							v-model="form.price_field"
							slot="prepend"
						>
							<el-option label="成本价" value="min_cost_price"></el-option>
							<el-option label="在售价" value="min_sale_price"></el-option>
							<el-option label="供货价" value="min_supply_price"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :span="2" style="text-align:center;">至</el-col>
				<el-col :span="7">
					<el-input v-model="form.max_sale_price" placeholder="输入最高价格" />
				</el-col>
			</el-form-item>

			<el-form-item label="商品名称：">
				<el-input
					style="width:200px;"
					v-model="form.title_keywords"
					placeholder="输入商品名称搜索"
				/>
			</el-form-item>
			<el-form-item label="商品编号：">
				<el-input
					style="width:200px;"
					v-model="form.product_no_keywords"
					placeholder="输入商品编号搜索"
				/>
			</el-form-item>
			<el-form-item label="负责人：">
				<el-input
					style="width:200px;"
					v-model="form.charge_name"
					placeholder="输入负责人姓名"
				/>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSearchClick">查询</el-button>
				<el-button type="success" @click="resetForm('filtrateForm')"
					>重置</el-button
				>
				<el-button type="danger" @click="onExportClick">导出</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->
		<el-table
			:data="tableData"
			border
			style="width:100%;"
			max-height="600"
			:cell-style="tc"
			:header-cell-style="tccolor"
			ref="table"
			@sort-change="onSortChange"
			@selection-change="onSelectionChange"
			v-loading="listLoading"
		>
			<el-table-column type="selection" fixed width="55"></el-table-column>
			<el-table-column
				prop="product_no"
				label="商品ID"
				width="140"
			></el-table-column>
			<el-table-column label="商品图" width="100">
				<template slot-scope="scope">
					<img
						style="width:56px;height:56px;object-fit:cover;"
						:src="scope.row.img_url"
						alt
					/>
				</template>
			</el-table-column>
			<el-table-column label="来源" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_channel">
						{{ scope.row.supplier_channel.name }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>
			<el-table-column label="供应商" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_name">
						{{ scope.row.supplier_name }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column label="对接方式" width="100">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_channel">
						<p v-if="scope.row.supplier_channel.type == 0">自营创建</p>
						<p v-if="scope.row.supplier_channel.type == 1">1688接入</p>
						<p v-if="scope.row.supplier_channel.type == 2">供应商接入</p>
						<p v-if="scope.row.supplier_channel.type == 5">盈锐接入</p>
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>
			<el-table-column width="260" prop="title" label="商品名称">
				<template slot-scope="scope">
					<div style="padding:0 12px;">
						<el-input
							size="mini"
							:key="scope.row.id"
							v-model="scope.row.title"
							@change="onGoodsTitleChange(scope.row.id, $event)"
						>
							<i class="el-icon-edit el-input__icon" slot="suffix"></i>
						</el-input>
					</div>
				</template>
			</el-table-column>

			<el-table-column label="商品分类" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.cate">{{ scope.row.cate.name }}</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column label="税收分类" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.goods_class">{{ scope.row.goods_class }}</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column label="渠道起批量" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.min_order_quantity">
						{{ scope.row.min_order_quantity }}件
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column sortable="min_cost_price" label="成本价" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.min_cost_price">
						¥ {{ scope.row.min_cost_price }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column sortable="min_supply_price" label="供货价" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.min_supply_price">
						¥ {{ scope.row.min_supply_price }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column sortable="min_sale_price" label="建议零售价" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.min_sale_price">
						¥ {{ scope.row.min_sale_price }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column sortable="profit" label="商品利润" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.profit">¥ {{ scope.row.profit }}</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column
				sortable="sale_volume"
				prop="sale_volume"
				label="实际销量"
				width="120"
			>
				<template slot-scope="scope">
					<div v-if="scope.row.sale_volume">{{ scope.row.sale_volume }}件</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column width="100" label="是否推荐">
				<template slot-scope="scope">
					<div>
						<el-switch
							:key="scope.row.id"
							:active-value="1"
							:inactive-value="0"
							:value="scope.row.is_recommend"
							@change="onRecommendChange(scope.row.id, $event)"
						>
						</el-switch>
						<span
							v-if="scope.row.is_recommend == 1"
							style="margin-left:4px;color:#3498d8"
							>推荐</span
						>
						<span
							v-if="scope.row.is_recommend == 0"
							style="margin-left:4px;color:#999"
							>取消</span
						>
					</div>
				</template>
			</el-table-column>

			<!-- <el-table-column
				sortable="supply_chain_profit"
				prop="supply_chain_profit"
				label="渠道预估收益"
				width="140"
			></el-table-column> -->

			<el-table-column label="状态">
				<template slot-scope="scope">
					<div>
						<el-button
							size="mini"
							v-if="scope.row.status === 1"
							type="success"
							@click="onGoodsStatusChange([scope.row.id], 0)"
							>上架中</el-button
						>
						<el-button
							size="mini"
							v-if="scope.row.status == 2"
							type="info"
							@click="onGoodsStatusChange([scope.row.id], 1)"
							>已下架</el-button
						>
					</div>
				</template>
			</el-table-column>
			<el-table-column width="370" fixed="right" label="操作">
				<template slot-scope="scope">
					<div>
						<el-button
							size="mini"
							class="good-action-btn"
							@click="
								onTaxClick(
									scope.row.product_no,
									scope.row.goods_class,
									scope.row.force_zero_tax,
									scope.row.tax_class
								)
							"
							type="danger"
							>设置税收分类</el-button
						>
						<el-button
							size="mini"
							class="good-action-btn"
							@click="onEditClick(scope.row.id)"
							type="primary"
							>编辑</el-button
						>
						<el-button
							size="mini"
							class="good-action-btn"
							@click="watchGoodsSkuList(scope.row)"
							type="success"
							>查看SKU</el-button
						>
						<el-button
							size="mini"
							class="good-action-btn"
							@click="onDeleteClick([scope.row.id])"
							type="info"
							>删除</el-button
						>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="footer">
			<el-row>
				<el-col :span="6">
					<el-button
						v-show="tableData.length"
						@click="
							onGoodsStatusChange(
								selectedList.map(item => item.id),
								1
							)
						"
						:disabled="!selectedList.length"
						size="small"
						type="success"
						style="margin-bottom:12px;"
						>批量上架</el-button
					>
					<el-button
						v-show="tableData.length"
						@click="
							onGoodsStatusChange(
								selectedList.map(item => item.id),
								0
							)
						"
						:disabled="!selectedList.length"
						size="small"
						type="primary"
						>批量下架</el-button
					>
					<el-button
						v-show="tableData.length"
						@click="
							onDeleteClick(
								selectedList.map(item => item.id),
								0
							)
						"
						:disabled="!selectedList.length"
						size="small"
						type="info"
						>批量删除</el-button
					>
				</el-col>

				<el-col :span="18">
					<div class="pagination" v-show="tableData.length > 0">
						<el-pagination
							background
							@size-change="onSizeChange"
							@current-change="onPageChange"
							:current-page="form.page"
							:page-sizes="[20, 50, 100]"
							:page-size="form.size"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
						/>
					</div>
				</el-col>
			</el-row>
		</div>
		<SupplyPriceDialog :visible.sync="supplyPriceDialogVisible" />
		<OnSalePriceDialog :visible.sync="onSalePriceDialogVisible" />

		<gydialog title="设置税收分类" :visible.sync="showTax" width="440px">
			<el-form class="tax">
				<el-form-item label="税收分类：">
					<el-autocomplete
						style="width:250px;"
						popper-class="my-autocomplete"
						v-model="taxName"
						:fetch-suggestions="querySearch2"
						placeholder="请输入内容"
						@select="handleSelect2"
					>
						<template slot-scope="{ item }">
							<div class="name">{{ item.goods_name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="是否免税：">
					<el-select v-model="taxForm.force_zero_tax">
						<el-option label="否" :value="0"></el-option>
						<el-option label="是" :value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-button
				size="mini"
				class="tax-btn"
				@click="saveClassify"
				type="primary"
				>保存</el-button
			>
		</gydialog>

		<gydialog title="商品SKU详情" :visible.sync="ShowSkuDetail" width="640px">
			<skuModal
				:goodsId="currentGoodsId"
				:visible="ShowSkuDetail"
				@bugSkuGoods="bugSkuGoods"
			></skuModal>
		</gydialog>

		<gydialog title="商品采购" :visible.sync="showBuySku" width="800px">
			<buySku
				:goodsId="currentGoodsId"
				:skuId="skuId"
				:attribute="attribute"
				:visible="showBuySku"
				:deailInfo="goodsdetail"
				:supply_price="supply_price"
				@cancelShowBugSku="cancelShowBugSku"
			></buySku>
		</gydialog>
	</div>
</template>
<script>
import SupplyPriceDialog from '@/components/dialog/supplyPrice'
import OnSalePriceDialog from '@/components/dialog/onSalePrice'
import {
	productList,
	productCategoryGet,
	supplyChannel,
	getSuppliers,
	updateProductTitle,
	putOnProcut,
	pullOffProduct,
	updateRecommend,
	deleteProducts,
	getClass,
	classification
} from '@/api/goods'
import { BASE_API } from '@/config'
import skuModal from './skuModal'
import buySku from './buySku'
export default {
	data() {
		return {
			form: {
				page: 1,
				page_size: 20,
				price_field: '',
				title_keywords: '',
				product_no_keywords: '',
				cate_id: '',
				parent_id: '',
				min_sale_price: '',
				max_sale_price: '',
				sort: '',
				export: '',
				supply_id: '',
				docking_type: '',
				auto_sync: '',
				charge_name: '',
				supplier_id: ''
			},
			AutoVal: '',
			supplierName: '',
			supplyPriceDialogVisible: false,
			onSalePriceDialogVisible: false,
			//分类数据
			classifyList: [],
			//分类下对应的子分类
			sonClassifyList: [],
			//来源数据
			sourceList: [],
			//供应商数据
			supplierList: [],
			//商品数据
			tableData: [],
			//商品总数
			total: 0,
			listLoading: false,
			//勾选的条目
			selectedList: [],
			ShowSkuDetail: false,
			currentGoodsId: '',
			skuId: '',
			showBuySku: false,
			attribute: [],
			goodsdetail: {},
			supply_price: '',
			showTax: false,
			taxName: '',
			taxList: [],
			taxForm: {
				product_no: '',
				tax_class: '',
				force_zero_tax: ''
			}
		}
	},
	activated() {
		this.productCategoryGetData(0)
		this.supplyChannelListData()
		this.getSuppliersFn()
		this.taxListData()
	},
	methods: {
		querySearch(queryString, cb) {
			var restaurants = this.sourceList
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants
			// 调用 callback 返cb回建议列表的数据
			cb(results)
		},
		createFilter(queryString) {
			console.log(queryString)
			return sourceList => {
				return (
					sourceList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect(item) {
			console.log(item)
			this.form.supply_id = item.id
			this.AutoVal = item.name
		},
		querySearch1(queryString, cb) {
			var restaurants = this.supplierList
			console.log(restaurants)
			var results = queryString
				? restaurants.filter(this.createFilter1(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据；
			cb(results)
		},
		createFilter1(queryString) {
			console.log(queryString)
			return supplierList => {
				return (
					supplierList.supplier_name
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect1(item) {
			console.log(item)
			this.form.supplier_id = item.id
			this.supplierName = item.supplier_name
		},
		async querySearch2(queryString, cb) {
			console.log(queryString)
			try {
				let res = await getClass({
					goods_name: queryString
				})
				this.taxList = res
				var restaurants = res
				var results = restaurants
			} catch (e) {
				console.log(e)
			}
			// var restaurants = this.taxList
			// var results = queryString
			// 	? restaurants.filter(this.createFilter2(queryString))
			// 	: restaurants
			// 调用 callback 返回建议列表的数据；
			cb(results)
		},
		createFilter2(queryString) {
			return taxList => {
				return (
					taxList.goods_name
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect2(item) {
			console.log(item)
			this.taxForm.tax_class = item.serial_number
			this.taxName = item.goods_name
		},
		//添加商品
		onCreateClick() {
			window.open(window.location.href.split('goods/')[0] + 'goods/detail')
		},
		//设置默认供货价加润
		onSupplySettingClick() {
			this.supplyPriceDialogVisible = true
		},
		//设置默认在售价加润
		onSaleSettingClick() {
			this.onSalePriceDialogVisible = true
		},
		//根据一级分类改变
		classifyChange(id) {
			if (!id) {
				this.sonClassifyList = []
				this.form.cate_id = ''
				return
			}
			this.form.parent_id = id
			this.productCategoryGetData(1)
		},
		//点击查询
		onSearchClick() {
			this.onPageChange(1)
		},
		//重置筛选表单
		resetForm(formName) {
			this.$refs[formName].resetFields()

			this.form = {
				page: this.form.page,
				page_size: this.form.size,
				price_field: '',
				title_keywords: '',
				product_no_keywords: '',
				cate_id: '',
				parent_id: '',
				min_sale_price: '',
				max_sale_price: '',
				sort: '',
				export: '',
				supply_id: '',
				docking_type: '',
				auto_sync: '',
				charge_name: ''
			}
		},
		//导出
		onExportClick() {
			this.form.export = '1'
			this.getList()
		},
		//查看SKu
		watchGoodsSkuList(row) {
			this.currentGoodsId = row.id.toString()
			this.goodsdetail = row
			this.ShowSkuDetail = true
		},
		//
		onSortChange(e) {
			if (e.order) {
				if (e.order == 'ascending') {
					this.form.sort = e.column.sortable
				} else {
					this.form.sort = '-' + e.column.sortable
				}
			}
			this.onPageChange(1)
		},
		//勾选数据变化
		onSelectionChange(list) {
			console.log(list)

			this.selectedList = list
		},
		// 快速编辑商品标题
		onGoodsTitleChange(id, e) {
			if (e.length > 0) {
				this.updateProductTitleData(id, e)
			} else {
				this.$message.error('商品名称不能为空')
			}
		},
		//修改商品名称
		async updateProductTitleData(id, title) {
			let res = await updateProductTitle(id, { title: title })
			console.log(res)
			this.$message.success('修改成功')
		},

		// 快速改变商品推荐
		onRecommendChange(id, e) {
			if (e == 1) {
				//推荐
				this.updateRecommendData(id, { is_recommend: 1 })
			} else {
				//不推荐
				this.updateRecommendData(id, { is_recommend: 0 })
			}
		},
		//更改商品推荐
		async updateRecommendData(id, data) {
			updateRecommend(id, data).then(() => {
				this.$message.success('修改推荐状态成功')
				this.getList()
			})
		},
		//上下架
		onGoodsStatusChange(ids, status) {
			if (status === 0) {
				//下架
				this.pullOffProductData('[' + ids + ']')
			} else {
				//上架
				this.putOnProcutData('[' + ids + ']')
			}
		},
		//批量上架商品
		async putOnProcutData(ids) {
			await putOnProcut(ids).then(() => {
				this.$message.success('上架成功')
				this.getList()
			})
		},
		//批量下架
		async pullOffProductData(ids) {
			await pullOffProduct(ids).then(() => {
				this.$message.success('下架成功')
				this.getList()
			})
		},
		// 编辑商品
		onEditClick(id) {
			window.open(
				window.location.href.split('goods/')[0] + `goods/detail?id=${id}`
			)
		},
		// 删除商品
		onDeleteClick(ids) {
			deleteProducts({ ids: '[' + ids + ']' }).then(() => {
				this.$message.error('删除商品成功')
				this.getList()
			})
		},
		//批量删除商品

		onSizeChange(val) {
			this.form.page_size = val
			this.form.page = 1
			this.getList()
		},
		onPageChange(page) {
			this.form.page = page
			this.getList()
		},
		//获取商品数据
		async getList() {
			if (
				(this.form.min_sale_price || this.form.max_sale_price) &&
				!this.form.price_field
			) {
				this.$message.error('请选择价格区间类型')
				return
			}
			this.listLoading = true
			try {
				productList(this.form).then(res => {
					this.listLoading = false
					if (this.form.export == '1') {
						window.open(
							`${BASE_API}/admin/download/zip/${res[1].download_token}`
						)
						this.form.export = ''
					} else {
						let list = this.supplierList
						for (let i = 0; i < list.length; i++) {
							for (let j = 0; j < res.data.length; j++) {
								if (res.data[j].supplier_id == list[i].id) {
									res.data[j].supplier_name = list[i].supplier_name
								}
							}
						}
						this.tableData = res.data
						console.log(this.tableData)
						this.total = res.total
					}
				})
			} catch (e) {
				console.log(e)
			}
		},
		//获取商品分类
		async productCategoryGetData(type) {
			try {
				let res = await productCategoryGet({
					name: '',
					page: 1,
					page_size: 100,
					parent_id: this.form.parent_id,
					status: ''
				})
				if (type == 1) {
					this.sonClassifyList = res.data
				} else {
					this.classifyList = res.data
				}
			} catch (e) {
				console.log(e)
			}
		},
		//获取商品来源
		async supplyChannelListData() {
			try {
				let res = await supplyChannel({
					name: '',
					page: 1,
					size: 1000
				})
				this.sourceList = res.data
			} catch (e) {
				console.log(e)
			}
		},

		//获取税收分类
		async taxListData(goods_name = '') {
			try {
				let res = await getClass({
					goods_name
				})
				this.taxList = res
			} catch (e) {
				console.log(e)
			}
		},

		onTaxClick(id, goods_class, force_zero_tax, tax_class) {
			this.showTax = true
			;(this.taxName = goods_class),
				(this.taxForm = {
					product_no: id,
					tax_class,
					force_zero_tax
				})
		},

		//保存税收分类
		async saveClassify() {
			try {
				let res = await classification(this.taxForm)
				console.log(res)
				this.$message.success('保存成功')
				this.showTax = false
				this.taxForm = {
					product_no: '',
					tax_class: ''
				}
				this.getList()
			} catch (e) {
				console.log(e)
			}
		},

		//获取商品来源
		async getSuppliersFn() {
			try {
				let res = await getSuppliers({
					name: '',
					page: 1,
					size: 1000
				})
				this.supplierList = res
				this.getList()
			} catch (e) {
				console.log(e)
			}
		},
		bugSkuGoods(data) {
			this.skuId = data.id.toString()
			this.attribute = data.attribute
			this.supply_price = data.supply_price
			this.showBuySku = true
		},
		cancelShowBugSku() {
			this.showBuySku = false
		},
		tc() {
			return 'text-align:center; color:#333333; font-size:12px;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	},
	components: {
		SupplyPriceDialog,
		OnSalePriceDialog,
		skuModal,
		buySku
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';

.container {
	padding: 20px;
	text-align: left;

	.footer {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.tax-btn {
		display: block;
		margin: 0 auto 30px;
	}
	.tax{
		padding-top: 20px;
		.el-form-item{
			padding-left: 30px;
		}
	}
}
</style>
